import { DealerManagementService } from 'src/services/dealer-management.service';
import Header from '../header/header';
import { IUser } from 'src/utils/interfaces/user';
import Spinner from 'src/components/ui/spinner';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import { useEffect, useState } from 'react';
import './styles.scss';
interface IPropsTableItem {
    FIRSTNAME: String;
    LASTNAME: String;
    LOGIN: String;
    PARTYID: Number;
    PERMISSIONEXISTS: Number;
    STATUS: Number;
    DEALERIDS: String;
    STATUSTEXT: String;
    ID: string;
}

const UserDelete = () => {
    const { dsmSearch } = useSelector((state: IUser) => state);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState<true | false | null>(null);
    useEffect(() => {
        if (!dsmSearch.selectedUsers!.length)
            navigate('/dashboard/systemadmin/dealer-security-maintenance');
    }, []);
    const backClickHandler = () => {
        navigate('/dashboard/systemadmin/dealer-security-maintenance/search');
    };
    const sendToDelete = async () => {
        const service = new DealerManagementService();
        try {
            const users = (dsmSearch.selectedUsers ?? []).map((u) => ({
                username: u.LOGIN,
                userId: u.ID,
            }));

            setLoading(true);
            await service.deleteDSMUsers(users);
            setStatus(true);
        } catch {
            setStatus(false);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className='sys-admin-user-delete'>
            <Header />
            <div className='sys-admin-user-delete-body u-mt-large'>
                {status !== null ? (
                    <Notification
                        content={
                            status === true
                                ? 'User(s) successfully deleted.'
                                : 'An error occur removing the selected users. Please try again later.'
                        }
                        type={
                            status === true
                                ? NotificationType.SUCCESS
                                : NotificationType.ERROR
                        }
                        visibility={status !== null}
                        setVisibility={() => setStatus(null)}
                    />
                ) : null}
                <div className='page-title'>
                    <h5>Delete User Confirmation</h5>
                </div>
                <hr></hr>
                <p>
                    Are you sure you want to delete the following user(s)?
                    User(s) and their rights will be permanently deleted from
                    the Dealer Extranet and must be added as new to reactivate.
                </p>
                <span>
                    <strong>Selected User ID(s) prepared for deletion:</strong>
                </span>
                <ul className='u-mt-small u-flex'>
                    {dsmSearch.selectedUsers?.map(
                        (element: IPropsTableItem) => {
                            return (
                                <li
                                    key={element.ID}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <span>
                                        {element.FIRSTNAME} {element.LASTNAME}
                                    </span>
                                    <span>{element.LOGIN}</span>
                                    <span>
                                        {element.DEALERIDS.split(',').map(
                                            (ele, key) => {
                                                return (
                                                    <span
                                                        key={key}
                                                        style={{
                                                            marginRight: '5px',
                                                        }}
                                                    >
                                                        {ele}
                                                    </span>
                                                );
                                            },
                                        )}
                                    </span>
                                </li>
                            );
                        },
                    )}
                </ul>
                <div className='o-fieldset__row u-mt-large'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/1  u-1/1@s'>
                            <div className='o-fieldset__row button-group'>
                                <button
                                    className={
                                        'c-btn c-btn--secondary u-mr-small'
                                    }
                                    type='button'
                                    onClick={backClickHandler}
                                >
                                    <span className='c-btn__text'>Cancel</span>
                                </button>
                                <button
                                    className={'c-btn'}
                                    type='button'
                                    onClick={sendToDelete}
                                    disabled={loading || status === true}
                                >
                                    <span className='c-btn__text'>
                                        {loading ? (
                                            <div className='spinner-container'>
                                                <Spinner />
                                            </div>
                                        ) : (
                                            'Submit'
                                        )}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDelete;
